import React,{useEffect, useState} from 'react'
import guide from './userguide.pdf'
import { Box, Button, Typography } from '@mui/material';
import { PDFDocument } from 'pdf-lib'

const UserManual = () => {
    const [pdfURL,setPdfUrl] = useState('')
    useEffect(()=>{
        getFileDetails()
    },[])
    const getFileDetails = async () => {
        const response = await fetch(guide);
        const buffer = await response.arrayBuffer()
        const cleanBlob = await removeMetaData(buffer)
        let pdfurlstring = await URL.createObjectURL(cleanBlob)
        setPdfUrl(pdfurlstring)
    }
    const removeMetaData = async (pdfArrayBuffer: any) => {
        const pdfDoc = await PDFDocument.load(pdfArrayBuffer);
        pdfDoc.context.trailerInfo = {
            Info: undefined,
            Root: pdfDoc.context.trailerInfo.Root,
            ID: pdfDoc.context.trailerInfo.ID
        }
        const cleanPDF = await pdfDoc?.save();
        return new Blob([new Uint8Array(cleanPDF)], { type: 'application/pdf' });
    }
    return (
        <>
            {(window?.innerWidth > 500) ?
                <Box sx={{ height: '80vh', padding: '25px' }}>
                    <object
                        data={pdfURL}
                        type="application/pdf"
                        width="100%"
                        height="100%"
                    >

                        <iframe
                            src={pdfURL}
                            width="100%"
                            height="100%"
                        >
                            <p>
                                Your browser does not support PDFs.
                                <a href="https://example.com/test.pdf">Download the PDF</a>
                                .
                            </p >
                        </iframe >
                    </object>
                </Box > :
                <Box sx={{ margin: '80px auto' }}>
                    <Typography sx={{ fontSize: '16px' }}> User guide cannot be viewed in mobile. Please download to view the document. </Typography>
                    <Button href={guide} target="_blank" className='createSessionButton' variant="outlined" sx={{ width: '70%', marginTop: '25px', color: '#fff', background: '#005EB8', padding: '10px 0' }}>Download user guide</Button>
                </Box>
            }
        </>
    )
}
export default UserManual